import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import PartialDenturesContent from '../components/PartialDenturesContent';

const PartialDentures = () => {
  return (
    <div className="partial-dentures-container" c>
      <Header />
      <PartialDenturesContent />
      <Footer />
    </div>
  );
};

export default PartialDentures;